import { render } from "./CSNoteView.vue?vue&type=template&id=708a7581&scoped=true"
import script from "./CSNoteView.vue?vue&type=script&lang=js"
export * from "./CSNoteView.vue?vue&type=script&lang=js"

import "./CSNoteView.vue?vue&type=style&index=0&id=708a7581&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708a7581"]])

export default __exports__